import { render, staticRenderFns } from "./DataLoadingOverlay.vue?vue&type=template&id=2e0c9df2&scoped=true&"
import script from "./DataLoadingOverlay.vue?vue&type=script&lang=js&"
export * from "./DataLoadingOverlay.vue?vue&type=script&lang=js&"
import style0 from "./DataLoadingOverlay.vue?vue&type=style&index=0&id=2e0c9df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0c9df2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
